import { createContext, useContext, useState, useCallback, useMemo } from "react";

const PathSelectorContext = createContext(null);

export function PathSelectorProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [initialPath, setInitialPath] = useState(null);

  const openSelector = useCallback((path = null) => {
    setInitialPath(path);
    setOpen(true);
  }, []);

  const closeSelector = useCallback(() => setOpen(false), []);
  const value = useMemo(
    () => ({ open, initialPath, openSelector, closeSelector }),
    [open, initialPath, openSelector, closeSelector]
  );

  return (
    <PathSelectorContext.Provider value={value}>
      {children}
    </PathSelectorContext.Provider>
  );
}

export function usePathSelector() {
  const ctx = useContext(PathSelectorContext);
  if (!ctx) throw new Error("usePathSelector must be used within PathSelectorProvider");
  return ctx;
}
